(() => {
  const badges = Array.from(document.querySelectorAll('.cz-sale-toggle'));
  if (!badges.length) return;

  const HOLD_MS = 2000;
  const ENTRY_MS = 240;
  const phases = [
    { kind: 'sale', tone: 'red' },
    { kind: 'black-friday', tone: 'white' },
    { kind: 'offer', tone: 'red' },
    { kind: 'sale', tone: 'white' },
    { kind: 'black-friday', tone: 'red' },
    { kind: 'offer', tone: 'white' }
  ];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timers = new Set();
  const activeBadges = new Set();
  let currentIndex = 0;
  let basePhase = phases[currentIndex];

  const copy = {
    sale: 'SALE',
    'black-friday': 'BLACK FRIDAY',
    offer: 'EARLY BIRD'
  };

  const nextPhase = () => phases[(currentIndex + 1) % phases.length];

  const setLayer = (layer, phase) => {
    if (!layer) return;
    if (
      layer.dataset.czSaleKind === phase.kind &&
      layer.dataset.czSaleTone === phase.tone &&
      layer.textContent === copy[phase.kind]
    ) return;
    layer.dataset.czSaleKind = phase.kind;
    layer.dataset.czSaleTone = phase.tone;
    layer.textContent = copy[phase.kind];
  };

  const setBase = (phase, targets = badges) => {
    targets.forEach((badge) => setLayer(badge.querySelector('.cz-sale-toggle__base'), phase));
  };

  const clearTimers = () => {
    timers.forEach((timer) => window.clearTimeout(timer));
    timers.clear();
  };

  const schedule = (callback, delay) => {
    const timer = window.setTimeout(() => {
      timers.delete(timer);
      callback();
    }, delay);
    timers.add(timer);
    return timer;
  };

  const resetOverlays = (phase = nextPhase(), targets = badges) => {
    targets.forEach((badge) => {
      const overlay = badge.querySelector('.cz-sale-toggle__overlay');
      if (!overlay) return;
      overlay.classList.remove('is-entering');
      setLayer(overlay, phase);
    });
  };

  const enterNext = () => {
    if (document.hidden || reducedMotion.matches) {
      reset();
      return;
    }

    const nextIndex = (currentIndex + 1) % phases.length;
    const phase = phases[nextIndex];

    activeBadges.forEach((badge) => {
      const overlay = badge.querySelector('.cz-sale-toggle__overlay');
      if (!overlay) return;
      overlay.classList.remove('is-entering');
      setLayer(overlay, phase);
      overlay.classList.add('is-entering');
    });

    schedule(() => {
      currentIndex = nextIndex;
      basePhase = phase;
      const targets = Array.from(activeBadges);
      setBase(phase, targets);
      resetOverlays(nextPhase(), targets);
      schedule(enterNext, HOLD_MS);
    }, ENTRY_MS);
  };

  const runCycle = () => {
    schedule(enterNext, HOLD_MS);
  };

  const reset = () => {
    clearTimers();
    currentIndex = reducedMotion.matches || document.hidden ? 2 : 0;
    basePhase = phases[currentIndex];
    setBase(basePhase);
    resetOverlays(nextPhase());
    if (!reducedMotion.matches && !document.hidden) runCycle();
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const badge = entry.target;
        if (!entry.isIntersecting) {
          activeBadges.delete(badge);
          badge.querySelector('.cz-sale-toggle__overlay')?.classList.remove('is-entering');
          return;
        }
        activeBadges.add(badge);
        setLayer(badge.querySelector('.cz-sale-toggle__base'), basePhase);
        const overlay = badge.querySelector('.cz-sale-toggle__overlay');
        overlay?.classList.remove('is-entering');
        setLayer(overlay, nextPhase());
      });
    });
    badges.forEach((badge) => observer.observe(badge));
  } else {
    badges.forEach((badge) => activeBadges.add(badge));
  }

  reducedMotion.addEventListener?.('change', reset);
  document.addEventListener('visibilitychange', reset);
  reset();
})();
